import { TourKeys } from '@cast/constants';
import {
  useClusterEfficiencyTimeSeriesQuery as useClusterEfficiencyTimeSeriesQueryBase,
  type UseClustersTimedEfficiencyQueryArgs,
} from '@cast/shared-cost-data-access';

import { useTourStepId } from 'core/tour-v2/hooks/useTourStepId';

export const useClusterEfficiencyTimeSeriesQuery = (
  args: UseClustersTimedEfficiencyQueryArgs
) => {
  const tourStepKey = useTourStepId(TourKeys.OpinionatedPlatform);

  return useClusterEfficiencyTimeSeriesQueryBase(
    args,
    tourStepKey ?? undefined
  );
};
